import { endpoints } from "config/endpoints.config"
import { GenericResource, IGenericModel, generic } from "models/generic"

export enum PartnerType {
  DEFAULT = "default", // only invite and commission not inspection
  RESELLER = "reseller", // control payment and inspection
  MULTILEVEL = "multilevel", // 2%
}

export interface IWorkspace extends GenericResource {
  lastUpdateAt: string
  onlineAgents?: number
  onlineAgentsToday?: number
  activeSubscribers?: number
  activeTrials?: number
  activeOperatorsCount: number
  name?: string
  workspace?: string
  isActive: boolean
  avatar: string
  notes?: string
  wallet?: {
    balance: number
  }
  whatsappActiveChannelsCount: number
  instagramActiveChannelsCount: number
  partnerId?: number
  onboarding_color?: string
  token?: string
  onboarding_status?: string
  sms_credits?: number
  settings?: {
    about: {
      origin: string
      company_type: string
      job_role: string
      company_size: string
      objectives: string[]
    }
    voip: {
      enableRecording: boolean
      enableTranscribing: boolean
      enableSummaryPrompt: boolean
      summaryPrompt: string
    }
  }
  owner: {
    id: string
    avatar: string
    email: string
    name: string
    status: boolean
  }
  subscription: {
    id: string
    createdAt: string
    lastUpdateAt: string
    expiresAt: string
    autorenewal: boolean
    agents: number
    instagramUnits: number
    months: number
    numbers: number
    isActive: boolean
    license: string
    order: string
    status: string
    total: string
    whatsapp: boolean
    workspaceId: string
    discount: number
    smsUnits?: number
    version: string
  }
  subscription_v2: {
    current_plan: {
      resources: {
        operators: {
          units: 8
          discount: 99
          price: 79
        }
        channels: {
          unofficial_whatsapp: {
            discount: 99
            price: 249
            units: 2
          }
          instagram: {
            discount: 99
            price: 50
            units: 1
          }
        }
        sms: {
          price: 0.14
          units: 0
        }
      }
      total: 11.8
      prices_table_id: string
      discount_coupon_id: string
    }
    invoices: ["682618d122830d5201bd201d", "682620898c4b245b7911dbc3", "6826256ac8ce96625ee94579", "682628b4daaaab63e552f2a2"]
    invoice_notes: []
    _id: string
    workspace_id: "1"
    // history: [
    //   {
    //     current_plan: {
    //       resources: {
    //         operators: {
    //           units: number
    //           discount: number
    //           price: 79
    //         }
    //         channels: {
    //           unofficial_whatsapp: {
    //             discount: 0
    //             price: 249
    //             units: 5
    //           }
    //           official_whatsapp: {
    //             price: 249
    //             discount: 0
    //             units: 0
    //           }
    //           instagram: {
    //             discount: 0
    //             price: 50
    //             units: 1
    //           }
    //         }
    //         sms: {
    //           price: 0.14
    //           units: 0
    //         }
    //       }
    //       total: 2085
    //       prices_table_id: "66b3b45642c1ad3a4c82d935"
    //       discount_coupon_id: null
    //     }
    //     _id: "6822709747521a4b311c70fc"
    //     cycle_type: "monthly"
    //     type: "register"
    //     author_type: "system"
    //     author_id: null
    //     created_at: "2025-05-12T22:05:05.492Z"
    //     version: 1
    //   },
    //   {
    //     _id: "68261393191d2c4bd1e96efe"
    //     type: "cancel"
    //     author_type: "user"
    //     author_id: "5"
    //     created_at: "2025-05-15T16:17:23.257Z"
    //     version: 2
    //   },
    //   {
    //     current_plan: {
    //       resources: {
    //         operators: {
    //           units: 8
    //           discount: 0
    //           price: 79
    //         }
    //         channels: {
    //           unofficial_whatsapp: {
    //             discount: 0
    //             price: 249
    //             units: 2
    //           }
    //           instagram: {
    //             discount: 0
    //             price: 50
    //             units: 1
    //           }
    //         }
    //         sms: {
    //           price: 0.14
    //           units: 0
    //         }
    //       }
    //       total: 1180
    //       prices_table_id: "66b3b45642c1ad3a4c82d935"
    //       discount_coupon_id: null
    //     }
    //     _id: "682614c9191d2c4bd1e96f29"
    //     cycle_type: "monthly"
    //     type: "subscription"
    //     author_type: "user"
    //     author_id: "5"
    //     created_at: "2025-05-15T16:21:46.880Z"
    //     version: 3
    //   },
    //   {
    //     _id: "682617260fee3350a46b523d"
    //     type: "cancel"
    //     author_type: "user"
    //     author_id: "5"
    //     created_at: "2025-05-15T16:32:38.910Z"
    //     version: 4
    //   },
    //   {
    //     current_plan: {
    //       resources: {
    //         operators: {
    //           units: 8
    //           discount: 99
    //           price: 79
    //         }
    //         channels: {
    //           unofficial_whatsapp: {
    //             discount: 99
    //             price: 249
    //             units: 2
    //           }
    //           instagram: {
    //             discount: 99
    //             price: 50
    //             units: 1
    //           }
    //         }
    //         sms: {
    //           price: 0.14
    //           units: 0
    //         }
    //       }
    //       total: 11.8
    //       prices_table_id: "66b3b45642c1ad3a4c82d935"
    //       discount_coupon_id: "682275244b53c200ef3532e0"
    //     }
    //     _id: "682618a422830d5201bd2017"
    //     cycle_type: "monthly"
    //     type: "downgrade"
    //     author_type: "user"
    //     author_id: "5"
    //     created_at: "2025-05-15T16:38:31.935Z"
    //     version: 5
    //   },
    //   {
    //     _id: "68261ff9cb50865accce01b4"
    //     type: "cancel"
    //     author_type: "user"
    //     author_id: "5"
    //     created_at: "2025-05-15T17:10:17.215Z"
    //     version: 6
    //   },
    //   {
    //     current_plan: {
    //       resources: {
    //         operators: {
    //           units: 8
    //           discount: 99
    //           price: 79
    //         }
    //         channels: {
    //           unofficial_whatsapp: {
    //             discount: 99
    //             price: 249
    //             units: 2
    //           }
    //           instagram: {
    //             discount: 99
    //             price: 50
    //             units: 1
    //           }
    //         }
    //         sms: {
    //           price: 0.14
    //           units: 0
    //         }
    //       }
    //       total: 11.8
    //       prices_table_id: "66b3b45642c1ad3a4c82d935"
    //       discount_coupon_id: "682275244b53c200ef3532e0"
    //     }
    //     _id: "682620898c4b245b7911dbbe"
    //     cycle_type: "monthly"
    //     type: "edition"
    //     author_type: "user"
    //     author_id: "5"
    //     created_at: "2025-05-15T17:12:41.166Z"
    //     version: 7
    //   },
    //   {
    //     _id: "682622ef9249275ea13f582e"
    //     type: "cancel"
    //     author_type: "user"
    //     author_id: "5"
    //     created_at: "2025-05-15T17:22:55.899Z"
    //     version: 8
    //   },
    //   {
    //     current_plan: {
    //       resources: {
    //         operators: {
    //           units: 8
    //           discount: 99
    //           price: 79
    //         }
    //         channels: {
    //           unofficial_whatsapp: {
    //             discount: 99
    //             price: 249
    //             units: 2
    //           }
    //           instagram: {
    //             discount: 99
    //             price: 50
    //             units: 1
    //           }
    //         }
    //         sms: {
    //           price: 0.14
    //           units: 0
    //         }
    //       }
    //       total: 11.8
    //       prices_table_id: "66b3b45642c1ad3a4c82d935"
    //       discount_coupon_id: "682275244b53c200ef3532e0"
    //     }
    //     _id: "682623089249275ea13f583d"
    //     cycle_type: "monthly"
    //     type: "edition"
    //     author_type: "user"
    //     author_id: "5"
    //     created_at: "2025-05-15T17:23:20.935Z"
    //     version: 9
    //   },
    //   {
    //     _id: "6826253f55a73561e90013f0"
    //     type: "cancel"
    //     author_type: "user"
    //     author_id: "5"
    //     created_at: "2025-05-15T17:32:47.207Z"
    //     version: 10
    //   },
    //   {
    //     current_plan: {
    //       resources: {
    //         operators: {
    //           units: 8
    //           discount: 99
    //           price: 79
    //         }
    //         channels: {
    //           unofficial_whatsapp: {
    //             discount: 99
    //             price: 249
    //             units: 2
    //           }
    //           instagram: {
    //             discount: 99
    //             price: 50
    //             units: 1
    //           }
    //         }
    //         sms: {
    //           price: 0.14
    //           units: 0
    //         }
    //       }
    //       total: 11.8
    //       prices_table_id: "66b3b45642c1ad3a4c82d935"
    //       discount_coupon_id: "682275244b53c200ef3532e0"
    //     }
    //     _id: "68262569c8ce96625ee94574"
    //     cycle_type: "monthly"
    //     type: "edition"
    //     author_type: "user"
    //     author_id: "5"
    //     created_at: "2025-05-15T17:33:29.382Z"
    //     version: 11
    //   },
    //   {
    //     _id: "682628b0daaaab63e552f28e"
    //     type: "cancel"
    //     author_type: "user"
    //     author_id: "5"
    //     created_at: "2025-05-15T17:47:28.254Z"
    //     version: 12
    //   },
    //   {
    //     current_plan: {
    //       resources: {
    //         operators: {
    //           units: 8
    //           discount: 99
    //           price: 79
    //         }
    //         channels: {
    //           unofficial_whatsapp: {
    //             discount: 99
    //             price: 249
    //             units: 2
    //           }
    //           instagram: {
    //             discount: 99
    //             price: 50
    //             units: 1
    //           }
    //         }
    //         sms: {
    //           price: 0.14
    //           units: 0
    //         }
    //       }
    //       total: 11.8
    //       prices_table_id: "66b3b45642c1ad3a4c82d935"
    //       discount_coupon_id: "682275244b53c200ef3532e0"
    //     }
    //     _id: "682628b3daaaab63e552f29d"
    //     cycle_type: "monthly"
    //     type: "edition"
    //     author_type: "user"
    //     author_id: "5"
    //     created_at: "2025-05-15T17:47:31.962Z"
    //     version: 13
    //   },
    // ]
    cycle_type: "monthly"
    payment_method: "credit_card"
    start_at: string
    end_at: string
    discount_expires_at: null
    preferred_payment_due_date: 15
    status: string
    license: string
    current_invoice_reference: string
    version: 13
    integration_type: string
    integration_data: null
    extra_data: {
      customer_id: string
    }
    created_at: string
    updated_at: string
    __v: 0
    credit_card_id: string
    id: string
  }

  // Se é parceiro
  isPartner?: boolean
  partnerData?: {
    maxDiscount: number // Máximo desconto que pode dar para clientes
    maxCommission: number // Máxima comissão que o parceiro recebe
    type: PartnerType // Tipo de parceiro
  }

  // Se é cliente do parceiro
  customerPartnerData?: {
    commission?: number // % comissão que o parceiro recebe do cliente
    partnerId: string // Id do ambiente parceiro
    type?: PartnerType // Tipo de parceiro
  }[]

  billingData?: {
    customer: {
      name: string
      type: string
      phone: {
        ddd: string
        ddi: string
        number: string
        area_code: string
        country_code: string
      }
      emails: string[]
      address: {
        city: string
        state: string
        number: string
        street: string
        country: string
        zip_code: string
        neighborhood: string
      }
      country: string
      document: string
    }
  }
}

export const workspaces: IGenericModel<IWorkspace> = {
  ...generic(endpoints.ADMIN_WORKSPACES),
}
